
/**
 * Possible external events a component can support
 *
 * Name of event may be a DOM event, or a custom component event
 */
export const COMPONENT_ACTIONS = {

  onChange: 'onChange',
  onClick: 'onClick',

  onLoadOptions: 'onLoadOptions',
  onLoadCategoryOptions: 'onLoadCategoryOptions',
  onSearch: 'onSearch',

  onAddDocumentItem: 'onAddDocumentItem',
  onEditDocumentItem: 'onEditDocumentItem',
  onDeleteDocumentItem: 'onDeleteDocumentItem',
  onSelectDocumentItem: 'onSelectDocumentItem',
  onCopyDocumentItem: 'onCopyDocumentItem',

  onEditDocument: 'onEditDocument',
  onDeleteDocument: 'onDeleteDocument',
  onDuplicateDocument: 'onDuplicateDocument',

  onSubmitDocument: 'onSubmitDocument',
  onCloseDocument: 'onCloseDocument',

  onLoadBowtie: 'onLoadBowtie',
  onLoadPermissions: 'onLoadPermissions'
};
